// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__15ICG","avatar":"style_avatar__1Hoh8"};